import Api from "@/api/api";

const UserService = {
    getUser() {
        return Api().get(`/user/`);
    },
    getDomainList() {
        return Api().get(`/user/domainList`);
    },
};

export default UserService;